import { Language } from "@mui/icons-material";
import { Box, Button, Card, CardContent, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { GB, IT, SI } from 'country-flag-icons/react/3x2';
import I18n, { changeLanguage } from 'i18next';
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Background from "../../assets/background.png";
import LoginLogo from "../../assets/beetogether-logo-520x520.png";

interface ISuccessRedirectProps { }

const SuccessRedirect: FC<ISuccessRedirectProps> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const locale = I18n.language;
    const [anchorElLang, setAnchorElLang] = useState<null | HTMLElement>(null);
    const [language, setLanguage] = useState(locale);

    const lang = [
        { flag: <GB title="English" />, label: I18n.t("EN", { locale: language }), value: "en-EN" },
        { flag: <IT title="Italy" />, label: I18n.t("IT", { locale: language }), value: "it-IT" },
        { flag: <SI title="Slovenian" />, label: I18n.t("SL", { locale: language }), value: "sl-SI" },
    ]

    const handleOpenLangMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElLang(event.currentTarget);
    };

    const handleCloseLangMenu = (option: { label: string, value: string }) => {
        if (locale !== option.value) {
            setLanguage(option.value)
            changeLanguage(option.value);
        }
        setAnchorElLang(null);
    };


    return <Box sx={
        {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            backgroundRepeat: "none",
            backgroundSize: "cover",
            backgroundImage: `url(${Background})`,
            backgroundPosition: "center"
        }
    }>
        <Card sx={{ width: 380, p: 1, m: 2, position: "relative" }}>
            <Tooltip title={t("header.selectLanguage")} sx={{ position: "absolute", top: 8, right: 12 }}>
                <IconButton onClick={handleOpenLangMenu} color="primary">
                    <Language />
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElLang}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElLang)}
                onClose={handleCloseLangMenu}
            >
                {lang.map((option) => (
                    <MenuItem key={option.label} onClick={() => handleCloseLangMenu(option)}>
                        <Box sx={{
                            width: 28,
                            height: 19,
                            mr: 1
                        }}>{option.flag}</Box>
                        <Typography textAlign="center">{option.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>
            <Box sx={{ display: "flex", justifyContent: "center", m: 2, mb: 0 }}>
                <Box
                    component="img"
                    sx={{ height: "160px" }}
                    src={LoginLogo}
                    title="bee2gether-logo"
                ></Box>
            </Box>
            <CardContent sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>
                    {location.pathname.includes("activated") && t("registerSuccess.title")}
                    {location.pathname.includes("password") && t("changePasswordSuccess.title")}
                </Typography>
                <Typography variant="body1" sx={{ textAlign: "center", mb: 2 }}>
                    {location.pathname.includes("activated") && t("registerSuccess.message")}
                    {location.pathname.includes("password") && t("changePasswordSuccess.message")}
                </Typography>
                <Box sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
                    <Button variant="contained" onClick={() => navigate("/login")}>
                        {t("navigateLogin")}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    </Box>
}

export default SuccessRedirect;